import { useCallback, useEffect, useRef } from 'react'
import useClevertapForSrp from '../../analytics/clevertap/srp'
import useGetSearchQueryURL from '../getSearchQueryURL'
import useUpdateSearchResultCache from '../updateSearchResultCache'
import useSearchResults from '../useSearchResults'

export const useInitialFilterHandler = () => {
    const { applyInitialStopsFilter } = useGetSearchQueryURL()
    const { selectedJourneyLeg, srpResultsLoading, srpResultsError } = useSearchResults()
    const updateCache = useUpdateSearchResultCache()
    const { triggerSrpEvent } = useClevertapForSrp()

    const applyInitialFilter = useCallback(() => {
        updateCache(currentData => {
            if (currentData?.filterData?.NewStops?.[selectedJourneyLeg]) {
                currentData.filterData.NewStops[selectedJourneyLeg].selectedValues = [0]
            }
            return currentData as NonNullable<typeof currentData>
        })
    }, [updateCache, selectedJourneyLeg])

    const shouldApplyInitialFilter = applyInitialStopsFilter && applyInitialStopsFilter !== null && applyInitialStopsFilter !== undefined

    const isBothLegInitialFilterApplied = useRef(false)
    useEffect(() => {
        if (
            shouldApplyInitialFilter &&
            !srpResultsLoading &&
            !srpResultsError &&
            !isBothLegInitialFilterApplied.current
        ) {
            applyInitialFilter()

            if (selectedJourneyLeg === 1) {
                isBothLegInitialFilterApplied.current = true
            }
        }
    }, [shouldApplyInitialFilter, srpResultsLoading, srpResultsError, selectedJourneyLeg])


    useEffect(() => {
        if (shouldApplyInitialFilter) {
            triggerSrpEvent('Air_UI_Action', {
                action_name: 'searched_with_non_stop_filter',
                action_type: 'BUTTON',
                action_value: applyInitialStopsFilter
            })
        }

    }, [shouldApplyInitialFilter, applyInitialStopsFilter])

}
